#import "~/graphql/fragments/pageContent/toegewezenBijdragenContent.graphql"

query getToegewezenBijdragen(
    $site: [String!]
    $section: [String]
    $search: String
    $limit: Int
    $offset: Int
    $orderBy: String
    $relatedToCategories: [CategoryRelationCriteriaInput]
    $dateRange: [QueryArgument]
) {
    entries(
        site: $site,
        section: $section
        search: $search
        limit: $limit
        offset: $offset
        orderBy: $orderBy
        relatedToCategories: $relatedToCategories
        plainDate: $dateRange
    ) {
        ...toegewezenBijdragenContent
    }
    entryCount(
        site: $site
        section: $section
        search: $search
        relatedToCategories: $relatedToCategories
        plainDate: $dateRange
    )
}
